import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <main className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-empire-black px-6 text-center">
      <Seo title="Page Not Found — 4EMPIRE" description="The page you are looking for does not exist." />
      <div className="absolute inset-0 bg-grid" aria-hidden="true" />
      <div className="halo-red pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full" aria-hidden="true" />
      <div className="relative z-10">
        <p className="font-anton text-[8rem] leading-none text-outline-red sm:text-[12rem]" data-testid="notfound-code">
          404
        </p>
        <h1 className="mt-6 font-anton text-3xl uppercase tracking-wide sm:text-4xl" data-testid="notfound-heading">
          This page left the empire.
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-empire-mist">
          The page you are looking for doesn&apos;t exist or has been moved. Let&apos;s get you back
          on track.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="notfound-home-button"
            className="bg-empire-red px-8 py-4 font-grotesk text-xs uppercase tracking-[0.2em] text-white transition-colors hover:bg-empire-glow"
          >
            Back to Home
          </Link>
          <Link
            to="/contact"
            data-testid="notfound-contact-button"
            className="border border-white/20 px-8 py-4 font-grotesk text-xs uppercase tracking-[0.2em] text-white transition-colors hover:border-empire-red hover:text-empire-red"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </main>
  );
}
